// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2pEsB","label":"CategoryService_label__2Xd2p","location":"CategoryService_location__3kBkm"};